import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const AdvokitPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f8edff',
      100: '#eddcff',
      200: '#d7baff',
      300: '#ba9fe2',
      400: '#9f85c6',
      500: '#856baa',
      600: '#6b538f',
      700: '#533b76',
      800: '#3b245e',
      900: '#260c47',
      950: '#13002f'
    }
  }
});
